module.exports = __webpack_public_path__ + "img/wangchengyao.c710e75f.png";